import { Component, Input, ElementRef, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';
import { GestockService } from '../services/gestock.service';
import html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-facture',
  templateUrl: './facture.component.html',
  styleUrls: ['./facture.component.css']
})
export class FactureComponent implements OnInit {
  @Input() customer: any;
  @Input() items: any[] = [];
  @Input() allQtsOnCart: any[] = [];
  @Input() factureId: string = '';
  @Input() date: string = new Date().toLocaleDateString('fr-FR');
  @Input() vendeurName: string = '';
  @Input() montantrecu: any;

  @ViewChild('factureContent') factureContent!: ElementRef;

  @Output() factureRetourInfoEvent = new EventEmitter<any>();

  shopInfo: any = null;

  constructor(private gestockService: GestockService) { }

  ngOnInit(): void {
    this.loadShopInfo();
    if (!this.vendeurName) {
      this.vendeurName = sessionStorage.getItem("tourouwaadji") || '';
    }
    console.log("Nom Vendeur :", this.vendeurName);
  }

  loadShopInfo() {
    const samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");

    if (samacaabiyoonwii) {
      this.gestockService.getShopInfo(samacaabiyoonwii).then(res => {
        if (res.statutreq === 1 && res.data) {
          this.shopInfo = res.data;
        }
      });
    }
  }


  get total(): number {
    return this.items.reduce((sum, item, index) => {
      const qte = Number(this.allQtsOnCart[index]) || 0;
      const price = this.getItemPrice(item);
      return sum + (qte * price);
    }, 0);
  }

  getItemPrice(item: any): number {
    if (!item) return 0;
    if (item.prix !== undefined && item.prix !== null) return Number(item.prix);
    if (item.price !== undefined && item.price !== null) return Number(item.price);
    return 0;
  }

  getItemDesignation(item: any): string {
    if (!item) return '';
    return item.name || item.nom_article || item.nom || item.designation || '';
  }

  getCustomerName(): string {
    if (!this.customer) return '';
    return this.customer.companyName || 
           this.customer.fullName || 
           this.customer.prenomnom || 
           this.customer.nomComplet || 
           ((this.customer.prenom || '') + ' ' + (this.customer.nom || '')).trim() || 
           this.customer.raisonSociale || '';
  }

  getCustomerAddress(): string {
    if (!this.customer) return 'DAKAR/SENEGAL';
    return this.customer.address || this.customer.adresse || this.customer.adresseClient || 'DAKAR/SENEGAL';
  }

  imprimer() {
    this.factureContent.nativeElement.print();
  }

  imprimerSection() {
    const printContent = this.factureContent.nativeElement.innerHTML;
    const WindowPrt = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    if (WindowPrt) {
      WindowPrt.document.write(`
        <html>
          <head>
            <title>Facture</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { padding: 8px; border: 1px solid #ddd; text-align: left; }
              h2, h3, p { margin: 0 0 10px; }
            </style>
          </head>
          <body onload="window.print(); window.close()">
            ${printContent}
          </body>
        </html>
      `);
      WindowPrt.document.close();
    }
  }

  formatMoney(montant: any) {
    let dollarUSLocale = Intl.NumberFormat('fr-FR');
    return dollarUSLocale.format(montant || 0);
  }

  exporterPDF() {
    const options = {
      margin: 10,
      filename: `facture-${this.factureId}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf().from(this.factureContent.nativeElement).set(options).save();
  }

  getRestant() {
    return Number(this.total) - Number(this.montantrecu || 0);
  }

  fermerLeProcessusDeCommande() {
    this.factureRetourInfoEvent.emit(1);
  }
}
